/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "c72fa6f0a4627569ab4df11192e3513d0b152ba2";
